"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmetAsync = require("react-helmet-async");

var _url = require("./lib/url");

var ALLOW_DUPLICATE_TAGS = ['og:locale:alternate'];
/**
 * Generates og:locale:alternative head tags from available locales
 *
 * @param {Array<String>} availableLocales
 * @param {String} locale
 * @returns {Array<Object>}
 */

function getGeneratedHeadData(availableLocales, locale) {
  var alternativeLocales = (0, _toConsumableArray2["default"])(availableLocales);
  alternativeLocales.splice(availableLocales.indexOf(locale), 1);
  return alternativeLocales.map(function (locale) {
    return {
      name: 'og:locale:alternate',
      content: locale
    };
  });
}
/**
 * Builds the head tags from three sources from highest to lowest priority i.e.
 * component overwrites duplicate page or site meta data and so on and so forth
 *
 *  - component level meta data
 *  - page level meta data
 *  - site level meta data
 *
 *
 * @param {Object} params
 * @param {Object} params.componentHeadData
 * @param {Object} params.pageHeadData
 * @param {Object} params.siteHeadData
 * @param {Array<String>} params.availableLocales
 * @param {String} params.locale
 * @param {String} params.url
 * @returns {Object} object with title and complete meta array
 */


function getHeadData(_ref) {
  var component = _ref.component,
      page = _ref.page,
      site = _ref.site,
      availableLocales = _ref.availableLocales,
      locale = _ref.locale,
      url = _ref.url;
  var filteredPage = {};
  Object.keys(page).forEach(function (key) {
    if (page[key]) filteredPage[key] = page[key];
  });
  var componentMeta = component.meta || [];

  if (component.title) {
    componentMeta.push({
      name: 'twitter:title',
      content: component.title
    });
    componentMeta.push({
      name: 'og:title',
      content: component.title
    });
  }

  var metaNames = [];
  var meta = [];
  var unfilteredMeta = [].concat((0, _toConsumableArray2["default"])(getGeneratedHeadData(availableLocales, locale)), (0, _toConsumableArray2["default"])(componentMeta), (0, _toConsumableArray2["default"])(filteredPage.meta || []), (0, _toConsumableArray2["default"])(site.meta || []));

  var getFileURL = function getFileURL(file) {
    return (0, _url.isRelative)(file) ? "".concat(url).concat(file) : file;
  };

  unfilteredMeta.forEach(function (tag) {
    if (!tag.content && !tag.file) return;
    if (ALLOW_DUPLICATE_TAGS.includes(tag.name) || !metaNames.includes(tag.name)) meta.push({
      name: tag.name,
      content: tag.content || getFileURL(tag.file)
    });
    metaNames.push(tag.name);
  });
  return {
    title: component.title || filteredPage.title || site.title,
    meta: meta.map(function (tag) {
      if (tag.name.match(/^og:/)) return {
        property: tag.name,
        content: tag.content
      };
      return tag;
    })
  };
}

var Head = function Head(_ref2) {
  var _ref2$site = _ref2.site;
  _ref2$site = _ref2$site === void 0 ? {} : _ref2$site;
  var _ref2$site$title = _ref2$site.title,
      siteTitle = _ref2$site$title === void 0 ? '' : _ref2$site$title,
      _ref2$site$meta = _ref2$site.meta,
      siteMeta = _ref2$site$meta === void 0 ? [] : _ref2$site$meta,
      _ref2$page = _ref2.page;
  _ref2$page = _ref2$page === void 0 ? {} : _ref2$page;
  var _ref2$page$title = _ref2$page.title,
      pageTitle = _ref2$page$title === void 0 ? '' : _ref2$page$title,
      _ref2$page$meta = _ref2$page.meta,
      pageMeta = _ref2$page$meta === void 0 ? [] : _ref2$page$meta,
      _ref2$component = _ref2.component;
  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var _ref2$component$title = _ref2$component.title,
      componentTitle = _ref2$component$title === void 0 ? '' : _ref2$component$title,
      _ref2$component$meta = _ref2$component.meta,
      componentMeta = _ref2$component$meta === void 0 ? [] : _ref2$component$meta,
      locale = _ref2.locale,
      _ref2$availableLocale = _ref2.availableLocales,
      availableLocales = _ref2$availableLocale === void 0 ? [] : _ref2$availableLocale,
      lang = _ref2.lang,
      url = _ref2.url,
      children = _ref2.children;
  var completeHeadData = getHeadData({
    component: {
      title: componentTitle,
      meta: componentMeta
    },
    page: {
      title: pageTitle,
      meta: pageMeta
    },
    site: {
      title: siteTitle,
      meta: siteMeta
    },
    availableLocales: availableLocales,
    locale: locale,
    url: url
  });
  return _react["default"].createElement(_reactHelmetAsync.Helmet, {
    title: completeHeadData.title,
    meta: completeHeadData.meta
  }, lang && _react["default"].createElement("html", {
    lang: lang
  }), children);
};

Head.propTypes = {
  site: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    meta: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      content: _propTypes["default"].string,
      file: _propTypes["default"].string
    }))
  }),
  page: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    meta: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      content: _propTypes["default"].string,
      file: _propTypes["default"].string
    }))
  }),
  component: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    meta: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      content: _propTypes["default"].string,
      file: _propTypes["default"].string
    }))
  }),
  locale: _propTypes["default"].string,
  availableLocales: _propTypes["default"].arrayOf(_propTypes["default"].string),
  lang: _propTypes["default"].string,
  url: function url(props, propName, componentName) {
    if (typeof props[propName] !== 'string') return new Error("'".concat(propName, "' prop for component '").concat(componentName, "' must be a string"));

    if (!props[propName].match(/^(https?:)\/\/[^/]+$/)) {
      return new Error("'".concat(propName, "' prop for component '").concat(componentName, "' must be a valid URL starting with \"http://\", \"https://\" or \"//\" with no trailing slash, e.g. \"https://example.org\" or \"http://localhost:8080\""));
    }
  },
  children: _propTypes["default"].node
};
var _default = Head;
exports["default"] = _default;